import {Component, OnInit}      from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Pagination}             from "../shared/api/pagination.interface";
import {Schema}                 from '../shared/api/bases/proxy/schemas/schema.interface';
import {Schemas}                from '../shared/api/bases/proxy/schemas/schemas.interface';
import {Api}                    from '../shared/api.service';
import {Base, BaseInterface}    from '../shared/api/bases/api.models';
import {tap}                    from 'rxjs/operators';
import {ModalService}           from '../shared/modal.service';
import {SchemaCopyModal}        from './schema-copy.modal';
import {SchemasService}         from './schemas.service';


@Component({
    selector : 'schemas',
    template: require('./schemas.component.html'),
    styles: [require('./schemas.component.scss')]
})

export class SchemasComponent implements OnInit {
    static ITEMS_PER_PAGE: number = 40;

    bases: BaseInterface[] = [];
    currentBase: BaseInterface;

    schemas: Schema[] = [];
    currentPage: number;
    perPage: number = SchemasComponent.ITEMS_PER_PAGE;
    collectionSize: number;
    isLoading: boolean = true;

    constructor(
        private route: ActivatedRoute,
        private api: Api,
        private modal: ModalService,
        private router: Router,
        private schemasService: SchemasService
    ) {}

    ngOnInit() {
        this.bases = this.route.snapshot.data['bases'];
        if (!this.schemasService.currentBaseName) {
            this.schemasService.currentBaseName = this.bases[0].name;
        }

        this.bases.forEach((base: Base) => {
            if (base.name === this.schemasService.currentBaseName) {
                this.currentBase = base;
            }
        });

        this.currentPage = 1;

        this.loadPage(this.currentPage);
    }

    loadPage(page: number) {
        this.isLoading = true;
        this.schemas   = [];
        this.schemasService.currentBaseName = this.currentBase.name;

        this.api.bases().proxy(this.currentBase.id).schemas().collection(page, this.perPage)
            .pipe(
                tap(() => this.isLoading = false)
            )
            .subscribe((schemas: Schemas) => {
                this.setSchemas(schemas.result);
                this.setPagination(schemas.pagination);
            });
    }

    public delete(schema: Schema) {
        if (schema.isActive === true) {
            return;
        }

        this.modal.confirm('Remove schema #' + schema.id, 'Are you sure you want to remove schema "' + schema.name + '"?').then(
            () => {
                this.api.bases().proxy(this.currentBase.id).schemas().remove(schema.id).subscribe(
                    () => this.schemas.splice(this.schemas.indexOf(schema), 1)
                )
            },
            () => {}
        );
    }

    public copy(schema: Schema) {
        let modal = this.modal.custom(SchemaCopyModal);
        modal.componentInstance.currentBase = this.currentBase;
        modal.componentInstance.toBase      = this.currentBase;
        modal.componentInstance.bases       = this.bases;
        modal.componentInstance.schema      = schema;

        modal.result.then(
            (result: any) => {
                this.router.navigateByUrl(
                    '/schemas/' + result.base.id + '/copy/' + this.currentBase.id + '/' + result.schema.id
                );
            },
            () => {}
        );
    }

    private setSchemas(schemas: Schema[]) {
        this.schemas = schemas;
    }

    private setPagination(pagination: Pagination) {
        this.currentPage    = pagination.current;
        this.collectionSize = pagination.total;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/schemas/schemas.component.ts